import { Outlet } from 'react-router-dom';
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import styles from './MainLayout.module.scss'; // 导入样式文件
// import { FloatButton } from 'antd';
// import { CustomerServiceOutlined } from '@ant-design/icons';
function MainLayout() {
  return (
    <div className="app">
      <Navbar />
      <div className={styles.content}>
        <Outlet />
      </div>
      <Footer />
      {/* <FloatButton icon={<CustomerServiceOutlined />} type="primary" style={{ insetInlineEnd: 24 }} /> */}
    </div>
  );
}

export default MainLayout;